import type {DoppeFormActionSettings} from '../../client-server-common/types/doppe-form-action-settings';
import {
    getDefaultDoppeFormActionSettings,
    prepareFormSettingsForViewer
} from '../../client-server-common/types/doppe-form-action-settings';
import type {DoppeHideableValue} from '../../client-server-common';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    DoppeAutomationTriggers,
    doppePremiumFeatureIsDisabled,
    DoppePremiumFeatures,
} from '../../client-server-common';
import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import type {Values} from '@wix/devzai-utils-common';
import {
    DoppeActionTypeSubscribeViewerLang
} from '../doppe-action-type-subscribe/doppe-action-type-subscribe-viewer.lang';
import {
    SubscribeActionFormSubscriptionOptions
} from '../doppe-action-type-subscribe/doppe-action-type-subscribe-metadata';

export const LockSubscribeActionFormSubscriptionOptions = {
    Email: 'Email',
    Phone: 'Phone'
} as const;

export type LockSubscribeActionFormSubscriptionOptions = Values<typeof LockSubscribeActionFormSubscriptionOptions>;

export namespace DoppeLockActionTypeSubscribe {

    export interface ActionSettings extends DoppeFormActionSettings{
        subscribeButtonText: DoppeHideableValue<string>;
        enableEmailSubscribeOption: boolean;
        enablePhoneSubscribeOption: boolean;
        defaultSubscribeOption: LockSubscribeActionFormSubscriptionOptions;
    }
}

export const doppeLockActionTypeSubscribe = doppeActionTypeDefineMetadata<DoppeLockActionTypeSubscribe.ActionSettings>({
    id: 'co.hopp.lockAction/subscribe-form-lock',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        enableEmailSubscribeOption: true,
        enablePhoneSubscribeOption: false,
        defaultSubscribeOption: SubscribeActionFormSubscriptionOptions.Email,
        subscribeButtonText: DoppeActionTypeSubscribeViewerLang.defaultTexts.subscribeButtonText,
        ...getDefaultDoppeFormActionSettings()
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            subscribeButtonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText),
            customConsentText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            customThankYouMessage: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            customEmailForNotifications: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            creatorsListId: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.ListOfTexts, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            linkedWixSiteListId: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.ListOfTexts, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isFormAction: true,
    isLockAction: true,
    getSupportedAutomationTrigger: () => DoppeAutomationTriggers.SubscribeFormSubmitted,
    prepareForViewer: actionSettings => {
        prepareFormSettingsForViewer(actionSettings);
    },
    isPremiumAction: (premiumFeaturesStatus) => {
        return doppePremiumFeatureIsDisabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_form_submission)
    },
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    canRenderInPage: true,
})